var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTierEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.834 50C25.834 47.643 25.834 39.4645 26.5662 38.7322C27.2985 38 28.477 38 30.834 38H31.6673C33.2387 38 34.0243 38 34.5125 38.4882C35.0006 38.9763 35.0007 46.762 35.0007 48.3333V56.6667H25.834V50Z",
    stroke: "#141B34",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.001 51.6663C45.001 50.095 45.001 44.3093 45.4891 43.8212C45.9773 43.333 46.763 43.333 48.3343 43.333H49.1676C51.5247 43.333 52.7032 43.333 53.4354 44.0652C54.1676 44.7975 54.1676 50.976 54.1676 53.333V56.6663H45.001V51.6663Z",
    stroke: "#141B34",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.334 56.6665H56.6673",
    stroke: "#141B34",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.001 46.6665C35.001 44.3095 35.001 30.131 35.7332 29.3987C36.4654 28.6665 37.644 28.6665 40.001 28.6665C42.358 28.6665 43.5365 28.6665 44.2687 29.3987C45.001 30.131 45.001 44.3095 45.001 46.6665V56.6665H35.001V46.6665Z",
    stroke: "#141B34",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierEmpty);
export default __webpack_public_path__ + "static/media/tier-empty.30624f30875d645d468f9a4f4f0177b9.svg";
export { ForwardRef as ReactComponent };